(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
function initMarqueePause(root) {
  root.querySelectorAll('[data-marquee-pause]').forEach(function(button) {
    if (button.dataset.ready) return;
    button.dataset.ready = 'true';
    button.addEventListener('click', function() {
      var paused = button.closest('.promo-marquee').classList.toggle('is-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      button.textContent = paused ? '▶' : 'Ⅱ';
    });
  });
}
initMarqueePause(document);
document.addEventListener('shopify:section:load', function(event) { initMarqueePause(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestseller-gallery"] && !Shopify.designMode) return;
  try {
    
function initYorkshireBestsellers(root) {
  root.querySelectorAll('[data-yp-bestsellers]').forEach(function (section) {
    if (section.dataset.ypReady) return;
    section.dataset.ypReady = 'true';
    var track = section.querySelector('[data-yp-track]');
    var prev = section.querySelector('[data-yp-prev]');
    var next = section.querySelector('[data-yp-next]');
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    function move(direction) {
      var item = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({left:step * direction, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
}
initYorkshireBestsellers(document);
document.addEventListener('shopify:section:load', function (event) { initYorkshireBestsellers(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-strip"] && !Shopify.designMode) return;
  try {
    
function initPopularCategories(root) {
  root.querySelectorAll('[data-yp-popular]').forEach(function(section) {
    if (section.dataset.ypReady) return;
    section.dataset.ypReady = 'true';
    var track = section.querySelector('[data-yp-popular-track]');
    var prev = section.querySelector('[data-yp-popular-prev]');
    var next = section.querySelector('[data-yp-popular-next]');
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    function move(direction) {
      var item = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({left:step * direction, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    prev.addEventListener('click', function() { move(-1); });
    next.addEventListener('click', function() { move(1); });
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
}
initPopularCategories(document);
document.addEventListener('shopify:section:load', function(event) { initPopularCategories(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const ypMenuSets = {
    nav_category: [
      ['nature-coastal','coastal-ocean','travel-cities','flowers-botanicals','animals-pets'],
      ['ancient-empires','military-war','aircraft-aviation','historic-tanks-armoured-vehicles','naval-maritime','american-history-americana','british-history-culture','remembrance-art','japan-samurai-tokyo'],
      ['neon-retro','music-film','gaming-anime','fantasy-enchanted','celestial-astronomy','mythology-gods','cultural-folk-art','gothic-dark-academia','streetwear-hypebeast'],
      ['retro-synthwave','modern-figurative-art','sports','kids-nursery','religious-spiritual','quotes-pop-culture','kitchen-bar','christmas-seasonal']
    ],
    nav_style: [['style-retro-and-vintage','style-graffiti-and-pop-art','style-gothic-and-dark-academia','style-cultural-and-folk-art','style-modern-and-abstract'],['style-watercolour','style-typography','style-illustration-and-sketch','style-photography-and-collage','style-vintage-and-traditional']],
    nav_room: [['room-living-room','room-kitchen','room-hallway','room-home-office'],['room-bedroom','room-bathroom','room-childrens-room']]
  };
  let ypActiveMenu = null, ypMenuTrigger = null, ypMenuTimer;
  function ypPrepareMenu(panel) {
    if(panel.dataset.prepared) return;
    panel.dataset.prepared='true';
    const source=panel.querySelector('.yp-mega__source'), grid=panel.querySelector('.yp-mega__grid');
    const links=Array.from(source.querySelectorAll('a')), names=panel.dataset.groups.split('|');
    const sets=panel.hasAttribute('data-custom-menu')?[]:ypMenuSets[panel.dataset.ypPanel];
    function addGroup(title,items) {
      if(!items.length)return;
      const group=document.createElement('details'), summary=document.createElement('summary'), body=document.createElement('div');
      group.className='yp-mega__group';group.open=matchMedia('(min-width:750px)').matches;
      summary.textContent=title;summary.tabIndex=group.open?-1:0;body.className='yp-mega__links';
      items.forEach(a=>body.append(a));group.append(summary,body);grid.insertBefore(group,source);
    }
    sets.forEach((handles,i)=>addGroup(names[i],handles.flatMap(handle=>links.filter(a=>new URL(a.href).pathname.replace(/\/$/,'').split('/').pop()===handle))));
    addGroup(panel.dataset.more,Array.from(source.querySelectorAll('a')));
    source.remove();
  }
  function ypCloseMenu(restore=false) {
    clearTimeout(ypMenuTimer);
    if(ypActiveMenu)ypActiveMenu.hidden=true;
    ypActiveMenu=null;
    document.querySelectorAll('.yp-hover-nav__toggle').forEach(b=>b.setAttribute('aria-expanded','false'));
    if(restore&&ypMenuTrigger)ypMenuTrigger.focus();
  }
  function ypOpenMenu(group,trigger) {
    clearTimeout(ypMenuTimer);ypMenuTrigger=trigger||group.querySelector('button');
    const panel=document.getElementById(group.querySelector('button').getAttribute('aria-controls'));
    if(ypActiveMenu!==panel)ypCloseMenu();
    ypPrepareMenu(panel);ypActiveMenu=panel;panel.hidden=false;
    document.querySelectorAll('.yp-hover-nav[data-yp-menu="'+group.dataset.ypMenu+'"] button').forEach(b=>b.setAttribute('aria-expanded','true'));
  }
  document.addEventListener('pointerover',event=>{
    const header=event.target.closest('.yp-header');if(header)clearTimeout(ypMenuTimer);
    const group=event.target.closest('.yp-hover-nav');
    if(group&&event.pointerType==='mouse'&&matchMedia('(min-width:750px) and (hover:hover)').matches&&!group.contains(event.relatedTarget))ypOpenMenu(group);
  });
  document.addEventListener('pointerout',event=>{
    const header=event.target.closest('.yp-header');
    if(header&&!header.contains(event.relatedTarget)&&!header.contains(document.activeElement))ypMenuTimer=setTimeout(()=>ypCloseMenu(),180);
  });
  document.addEventListener('click',event=>{
    const toggle=event.target.closest('.yp-hover-nav__toggle');
    if(toggle){const group=toggle.closest('.yp-hover-nav');if(toggle.getAttribute('aria-expanded')==='true')ypCloseMenu();else ypOpenMenu(group,toggle);}
    if(event.target.closest('[data-yp-menu-close]'))ypCloseMenu(true);
    if(!event.target.closest('.yp-header'))ypCloseMenu();
  });
  document.addEventListener('keydown',event=>{
    const toggle=event.target.closest('.yp-hover-nav__toggle');
    if(toggle&&event.key==='ArrowDown'){event.preventDefault();ypOpenMenu(toggle.closest('.yp-hover-nav'),toggle);ypActiveMenu.querySelector(matchMedia('(max-width:749px)').matches?'summary':'.yp-mega__link').focus();}
    if(event.key==='Escape'&&ypActiveMenu){event.preventDefault();ypCloseMenu(true);}
    if(event.target.matches('.yp-mega__group > summary')&&matchMedia('(min-width:750px)').matches&&(event.key==='Enter'||event.key===' '))event.preventDefault();
  });
  document.addEventListener('focusout',event=>{if(event.target.closest('.yp-header')&&event.relatedTarget&&!event.relatedTarget.closest('.yp-header'))ypCloseMenu();});
  matchMedia('(max-width:749px)').addEventListener('change',()=>{
    ypCloseMenu();document.querySelectorAll('.yp-mega__group').forEach(g=>{g.open=matchMedia('(min-width:750px)').matches;g.querySelector('summary').tabIndex=g.open?-1:0;});
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.yp-currency[open]').forEach(function (control) {
      if (!control.contains(event.target)) control.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.yp-currency[open]').forEach(function (control) {
      if (control.contains(document.activeElement)) control.querySelector('summary').focus();
      control.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
